'use client'
import { ArthoNewsletterSubscribe } from '@/components/artho-embed/ArthoNewsletterSubscribe'
import parse from 'html-react-parser'

type ArthoEmbedHtmlProps = {
  html: string
  className?: string
}

export function ArthoEmbedHtml({ html, className }: ArthoEmbedHtmlProps) {
  return (
    <div className={className}>
      {parse(html)}
      <ArthoNewsletterSubscribe />
    </div>
  )
}